import { describeFairValueStatus } from "@/lib/valuation";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

/**
 * Bewertungs-Ampel (backlog.md -> Punkt 20): kompakter Grün/Gelb/Rot-Punkt für
 * Suchergebnisse und Screener-Zeilen, schon vor dem Öffnen der Detailseite. Nutzt
 * ausschließlich die bereits bestehende KGV-vs-Median-Logik (`describeFairValueStatus`,
 * dieselbe Baseline wie der existierende KGV-Alert) statt einer zweiten,
 * abweichenden Bewertungsheuristik. Fehlt KGV oder Median, ist der Punkt neutral/grau
 * statt rot - eine fehlende Einordnung darf nie wie "schlecht bewertet" aussehen.
 */
export function ValuationBadge({
  pe,
  sectorMedian,
  ownMedian,
}: {
  pe?: number;
  sectorMedian?: number;
  ownMedian?: number;
}) {
  const status = describeFairValueStatus(pe, sectorMedian, ownMedian);
  const label = status ? status.text : "Keine Bewertungseinordnung verfügbar (KGV oder Median fehlt).";
  const color = !status
    ? "bg-muted-foreground/30"
    : status.direction === "under"
      ? "bg-positive"
      : status.direction === "over"
        ? "bg-negative"
        : "bg-gold";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          role="img"
          aria-label={label}
          className={cn("inline-block h-2.5 w-2.5 shrink-0 rounded-full", color)}
        />
      </TooltipTrigger>
      <TooltipContent className="max-w-56">{label}</TooltipContent>
    </Tooltip>
  );
}
